/**
 * Provide a singleton that caches the user's connections and can be dependency injected into any view that needs them.
 */
import UserConnections from 'collections/connections/UserConnections';

import viewerSocialProfile from 'models/user/ViewerSocialProfile';

var userConnections;

if (typeof userConnections == 'undefined' && viewerSocialProfile.get('displayName')) {
    userConnections = new UserConnections([], {
        displayName: viewerSocialProfile.get('displayName')
    });
}

export default userConnections;
